import _ from "lodash";
import { getMultiLangValue, getCurrentLangText, getCurrentLangIndex } from "Pub/js/getMulti";
import platform from "Pub/js/platform";
const { PubSub, getBusinessInfo } = platform;
import { langCheck } from "Pub/js/utils";
import { RECENTVISIT } from "Pub/js/allApps";

export const GRID_COLS = 24; // 栅格列数
export const getGridRowHeight = gap => { // 栅格行高
    if (gap == 8) {
        return 40;
    }
    return 36;
};
//dnd type常量
export const DragTypes = {
    APP_GROUP: 'appGroup', //聚合应用
    APP_GROUP_ITEM: 'appGroupItem', //聚合应用内的应用
    SIDE_CARD: 'cardlist', //左侧SiderCard
    GROUP_ITEM: 'item', //分组
};

//应用默认尺寸
export const APP_DEFAULT_SIZE = {
    width: 2,
    height: 2,
};

//聚合应用默认尺寸
export const COMPACT_APP_DEFAULT_SIZE = {
    width: 8,
    height: 4,
};

//公共类部件appcode
export const PUB_WIDGET_APPCODES = {
    commonUsedApp: '10182003', //常用应用
    externalLinks: '10182004', //外部链接
    noviceGuide: '10182001', //新手引导
    quickLaunch: '10182005', // 快速发起
};

/**
 * 以卡片为单位，设置卡片属性值
 * @param {Array} cards
 * @param {String} property
 * @param {*} value
 */
export const setPropertyValueForCardsInCards = (cards, property, value) => {
    _.forEach(cards, a => {
        a[property] = value;
    });
};

/**
 * 获得新添加组的数字
 * @param {Array} groups
 * @param {Int} myCount
 * @returns {Int}
 */
export const getNewGroupItemNum = (groupNameNation, groups, myCount) => {
    return genNameNum({
        nameNation: groupNameNation,
        data: groups,
        count: myCount,
        condition: (group, num) => group.groupname === `${groupNameNation}(${num})`,
    });
};

//生成新添加name的数字
export const genNameNum = ({
    nameNation,
    data,
    count,
    condition,
}) => {
    let num = count || 0;
    let numString = count || '';
    let existFlag = false;
    _.forEach(data, item => {
        if (condition(item, numString)) {
            existFlag = true;
            return false;
        }
    });
    if (existFlag) {
        return genNameNum({ nameNation, data, count: ++num, condition });
    } else {
        return numString;
    }
};
export const setGridXGridYMaxInCards = cardList => {
    _.forEach(cardList, c => {
        c.gridy = 999;
    });
};

/**
 * 判断分组内是否有选中的卡片
 * @param {Array} groups
 * @returns {Boolean}
 */
export const hasCheckedCardInGroups = groups => {
    let flag = false;
    _.forEach(groups, g => {
        _.forEach(g.apps, a => {
            if (a.isChecked === true) {
                flag = true;
                return false;
            }
        });
        if (flag) {
            return false;
        }
    });
    return flag;
};

//检查聚合应用内是否有选中应用
export const hasCheckedCardInCompactApp = appGroupMap => {
    const apps = _.flatten(Object.values(appGroupMap));
    const target = apps.find(item => item.isChecked === true);
    return !!target;
};

/**
 * 判断是否有过期的卡片
 * @param {Array} groups 分组
 * @param {Object} appGroupMap 常用应用
 * @returns {Boolean}
 */
export const hasExpiredCard = (groups, appGroupMap = {}) => {
    let flag = false;
    for (let g of groups) {
        flag = g.apps.some(a => a.haspower === false); // 必须明确用值比较，新拖拽出来的没有haspower字段
        if (flag) {
            return flag;
        }
    }
    
    for (let k in appGroupMap) {
        const children = appGroupMap[k];
        if (Array.isArray(children)) {
            flag = children.some(item => item.apptype && item.haspower === false); // 这里先不考虑快速发起的(有apptype表示非快速发起数据)，那个没权限是另外一个字段
            if (flag) {
                return flag;
            }
        }
    }
    return flag;
};

/**
 * 删除目标若干卡片
 * @param {Array} groups
 * @param {String} property 属性
 * @param {*} value 值
 */
export const removeTargetCardsInGroup = (groups, property, value) => {
    _.forEach(groups, g => {
        _.remove(g.apps, a => {
            return a[property] === value;
        });
    });
};

/**
 * 获得RelateObj
 * @param {String} pk_responsibility
 * @param {*} userID
 * @returns {Object}
 */
export const getRelateidObj = (pk_responsibility, is_group, workbenchid) => {
    let relateidObj;
    //0职责 1用户 2集团
    if (pk_responsibility) {
        relateidObj = {
            data: pk_responsibility,
            code: "0",
            type: "responsibility",
        };
    } else if (is_group) {
        relateidObj = {
            data: Boolean(is_group),
            code: "2",
            type: "is_group",
        };
    } else if (workbenchid) { // 工作台管理
        relateidObj = {
            data: workbenchid,
            code: "0",
            type: "workbench",
        };
    } else {
        relateidObj = {
            data: "",
            code: "1",
            type: "userID",
        };
    }
    return relateidObj;
};
/**
 * 判断所有分组内是否有某卡片
 * @param {Array} groups
 * @param {String} appid
 * @returns {Boolean}
 */
export const hasCardContainInGroups = (groups, appid) => {
    let flag = false;
    _.forEach(groups, g => {
        _.forEach(g.apps, a => {
            if (a.appid === appid) {
                flag = true;
                return false;
            }
        });
        if (flag) {
            return false;
        }
    });
    return flag;
};

/**
 * 生成卡片需要的数据
 *
 * @param {*} appGroupArr
 * @param {*} id
 * @returns {cardList}
 */
export const getCardList = (appGroupArr, id) => {
    let cardList = [];
    //将所有选中的Sider区域卡片，进行初始化
    _.forEach(appGroupArr, (a, groupIndex) => {
        _.forEach(a.children, (c, childIndex) => {
            //被勾选的或者当前拖拽的卡片，压栈进数组
            if (c.checked || c.value === id) {
                const commonObj = {
                    appcode: c.appcode,
                    cardid: c.value,
                    width: c.width > GRID_COLS ? GRID_COLS : c.width,
                    height: c.height,
                    name: c.name || c.label,
                    image_src: c.image_src,
                    apptype: c.apptype,
                    isShadow: false,
                    isChecked: false,
                    children: c.children, //聚合应用需要
                    isNotRepeat: c.isNotRepeat,
                };
                if (checkApp(c).isPublished) { // 发布出的部件
                    const { partdata } = c;
                    const { parttype } = partdata;
                    const parseSideData = getParseSideData(partdata);
                    cardList.push({
                        ...c,
                        ...commonObj,
                        sideData: parseSideData,
                        parttype,
                    });
                } else {
                    cardList.push({
                        ...c,
                        ...commonObj,
                    });
                }
            }
        });
    });
    return cardList;
};

//设置Grid的droppable属性
export function setGridDroppable(flag) {
    PubSub.publish('setGridDroppable', flag);
}

//获取两个对象数组去重后数据 compareKey:比较的key
export const getUniqueItems = (arr1, arr2, compareKey) => {
    const repeatCards = getRepeatItems(arr1, arr2, compareKey);
    if (repeatCards.length) {
        const repeatItemsKeys = repeatCards.map(item => item[compareKey]); //重复数组项的key
        const uniqueCards = arr2.filter(
            item => !repeatItemsKeys.includes(item[compareKey]),
        );
        return uniqueCards;
    }
    return [];
};

//获取对象数组重复项 compareKey:比较的key
export const getRepeatItems = (arr1, arr2, compareKey) => {
    let result = {};
    arr1.forEach(item => {
        let key = item[compareKey];
        if (!result.hasOwnProperty(key)) {
            arr2.forEach(card => {
                if (key === card[compareKey]) {
                    result[key] = card;
                }
            });
        }
    });
    return Object.values(result);
};

//检查card是否在聚合应用内
export const hasCheckedCardInAppGroup = (data, appid) => {
    const arr = Object.values(data);
    if (arr.length === 0) { return false; }
    const appGroupData = _.flatten(arr);
    const target = appGroupData.find(item => item && item.appid === appid);
    return target;
};

//判断应用类型
export const checkApp = (item = {}) => {
    const isCompactApp = item.appcode === PUB_WIDGET_APPCODES.commonUsedApp || item.appcode === PUB_WIDGET_APPCODES.quickLaunch;
    const isExternalLink = item.appcode === PUB_WIDGET_APPCODES.externalLinks;
    const isQuickLaunch = item.appcode === PUB_WIDGET_APPCODES.quickLaunch || item.source_app_code === PUB_WIDGET_APPCODES.quickLaunch;
    const isCommonFilter = item.appcode === '10182007';
    const isIndicatorCard = (item.source_app_code || item.appcode) === '10182006';
    const isBillStatistics = (item.source_app_code || item.appcode) === '10182008';
    const isCommonUsedApp = item.appcode === PUB_WIDGET_APPCODES.commonUsedApp;
    return {
        isApp: item.apptype === "1", //判断是否应用
        isWidget: item.apptype === "2", //判断是否部件
        isCompactApp, //判断是否聚合应用
        isExternalLink, //判断是否外部链接
        isOnlyWidget: item.apptype === "2" && !isCompactApp && !isExternalLink, //判断是否只是部件
        isAppOrLink: item.apptype === "1" || isExternalLink, //判断是应用或外部链接
        isQuickLaunch, // 判断是否快速发起
        isCommonFilter, // 是否为公共筛选器
        isIndicatorCard, // 指标卡
        isBillStatistics, // 单据统计
        isCommonUsedApp, // 常用应用
        isPublished: item.isreleasepart || (item.source_app_code && item.source_app_code !== item.appcode && item.partdata), // 发布出来的部件
    };
};

//生成随机的key
export const genRandomKey = (str = "") => new Date().valueOf() + `${str}`;

//根据聚合应用cardid找到所在分组
export const findDataByCompactApp = (groups, compactAppId) => {
    let result;
    groups.forEach((group, groupIndex) => {
        group.apps.some((app, appIndex) => {
            if (compactAppId === app.cardid) {
                result = { group, groupIndex, app, appIndex };
                return true;
            }
        });
    });
    return result;
};

/**
 * 计算元素放下后的位置
 *
 * @param {*} draggingItems 放置的元素
 * @param {*} startPos 放置的位置
 * 
 */
export function calcDraggingItemsPos(draggingItems, startPos) {
    const { x: startX, y: startY } = startPos;
    let items = _.sortBy(_.cloneDeep(draggingItems), ['height', 'width']); //先按高再按宽升序重新排列
    const itemsTotalWidth = draggingItems.reduce((count, item) => count + parseInt(item.width), 0); //拖拽元素总宽度
    const getCalcItems = (x, y = startY) => {
        //重新排列放置元素
        let newItems = [];
        items.reduce((prev, item, i) => {
            item.gridx = i === 0 ? x : prev.gridx + parseInt(prev.width);
            item.gridy = y;
            newItems = newItems.concat(item);
            return item;
        }, {});
        return newItems;
    };
    const getRowItems = x => {
        //拖拽元素宽度比当前行剩余栅格小直接放下
        if (itemsTotalWidth <= GRID_COLS - x) {
            return getCalcItems(x);
        } else {
            //拖拽元素比可放元素数量多左移放置
            return getRowItems(--x);
        }
    };
    //一行能放下
    if (itemsTotalWidth <= GRID_COLS) {
        return getRowItems(startX);
    } else {
        //多行
        return calcMultiItemsPosition(items, startPos);
    }
}

//计算多行放下后的位置
function calcMultiItemsPosition(draggingItems, { x: startX, y: startY }) {
    let sorItems = _.cloneDeep(draggingItems);
    //添加多行部件
    const getMultiRowItems = (y, result = []) => {
        let widthCount = 0;
        //把已添加的元素删掉
        const removeAddedItems = () => {
            let removeItems = [];
            const appcodes = result.map(item => item.appcode);
            if (appcodes.length) {
                removeItems = _.remove(sorItems, a => appcodes.includes(a.appcode));
            }
            return removeItems;
        };

        if (sorItems.length) {
            //使用try/catch为了跳出循环
            try {
                //使用reduce为了拿到上一次迭代的元素
                sorItems.reduce((prev, item, i) => {
                    widthCount += parseInt(item.width);
                    //超出一行跳出循环
                    if (widthCount > GRID_COLS) {
                        throw new Error(); //为了跳出循环
                    } else {
                        item.gridx = i === 0 ? 0 : prev.gridx + parseInt(prev.width);
                        item.gridy = y;
                        //找不到再push
                        if (!result.find(t => t.cardid === item.cardid)) {
                            result.push(item);
                        }
                        return item;
                    }
                }, {});
            } catch (e) { }
            const currentRowItems = removeAddedItems();
            //第一列元素高度
            const firstHeight = currentRowItems[0] && currentRowItems[0].height || 0;
            getMultiRowItems(y + firstHeight, result);
        }
        return result;
    };
    return getMultiRowItems(startY);
}

/**
 * 处理元素插入情况
 *
 * @param {*} droppedItems 放置的元素
 * @param {*} droppedPos 放置的位置
 * @param {*} apps 放置的分组应用
 * 
 */
export function processGroupItems(droppedItems, droppedPos, apps) {
    let sortedItems = _.sortBy(_.cloneDeep(apps), ['gridy']); //按行数升序重新排列
    let staticApps = sortedItems.filter(item => item.gridy < droppedPos.y); //不动的元素
    let newApps = sortedItems.filter(item => item.gridy >= droppedPos.y); //下移的元素
    newApps = newApps.map(item => {
        item.gridy = item.gridy + 99;
        return item;
    });
    let result = staticApps.concat(droppedItems.concat(newApps));
    result = _.uniqBy(result, "cardid");
    return result;
}

//获取职责页面查左树请求参数
export function getResponParams(relateidObj, queryUrl) {
    let ajaxData = {};
    if (relateidObj.type === "userID") {
        ajaxData = {};
    } else if (relateidObj.type === "is_group") {
        ajaxData = { is_group: relateidObj.data };
    } else if (relateidObj.type === "responsibility") {
        ajaxData = { pk_responsibility: relateidObj.data };
    }
    if (queryUrl && queryUrl.indexOf("pk_responsibility") !== -1) {
        let querySubString = queryUrl.substring(queryUrl.indexOf("pk_responsibility"));
        let relateid = querySubString.substring(querySubString.indexOf("=") + 1);
        ajaxData.pk_responsibility = relateid; //存relateid
    } else if (queryUrl && queryUrl.indexOf("is_group=true") !== -1) {
        // 集团管理员应用管理跳转工作桌面设置 2019-08-16
        ajaxData = { is_group: true };
    }

    // 当从职责-集团 跳桌面的时候 不需要请求bip的菜单
    if (queryUrl && queryUrl.indexOf("is_query_cloud=false") !== -1) {
        ajaxData = { ...ajaxData, ...{ is_query_cloud: false } };
    } else {
        ajaxData = { ...ajaxData, ...{ is_query_cloud: true } };
    }
    return { ...ajaxData, is_workbenchmanage: relateidObj.type === 'workbench' };
}

//生成聚合应用数据
export function createEmptyExternalLink(data, { cardid, name }) {
    let result = _.cloneDeep(data);
    result.cardid = cardid || genRandomKey('_new');
    result.name = name;
    result.parttype = "1"; //外部链接保存需要的字段 1表示外部链接
    result.width = result.width === undefined ? APP_DEFAULT_SIZE.width : result.width;
    result.height = result.height === undefined ? APP_DEFAULT_SIZE.height : result.width;
    return result;
}

//获取展开左边栏之后的缩放比例
export function getScale() {
    const hasEditingSider = document.querySelector('.desktop-has-editing-sider');
    const hasLeftSider = document.querySelector('.desktop-sider-expand');
    let desktopWidth = window.innerWidth;
    console.log(window.innerWidth)
    if (hasLeftSider) {
        desktopWidth -= 328; // 左侧栏宽度固定328
    }
    if (hasEditingSider) {
        desktopWidth -= 240; // 右侧编辑侧边栏宽度240
    }
    const zoomScale = window.innerWidth / desktopWidth; //放大比例
    const narrowScale = desktopWidth / window.innerWidth; //缩小比例
    return {
        zoom: +zoomScale.toFixed(4),
        narrow: +narrowScale.toFixed(4),
    };
}

// 如果是职责-集团跳 桌面配置 不需要请求bip的菜单
export const getQueryCloud = queryUrl => {
    if (queryUrl && queryUrl.indexOf("is_query_cloud=false") !== -1) {
        return { is_query_cloud: false };
    }
    return { is_query_cloud: true };
};

/**
 * 初始化桌面返回的数据
 *
 * @param {*} data 数据源
 * @param {*} customDeal 自定义处理函数
 * 
 */
export const initDesktopApp = (data, customDeal) => {
    const appGroupMap = {}; // 聚合应用数据
    _.forEach(data, g => {
        g.type = "group";
        _.forEach(g.apps, a => {
            a.isShadow = false;
            a.isChecked = false;
            // a.apptype = Number(a.apptype);
            a.gridx = Number(a.gridx);
            a.gridy = Number(a.gridy);
            a.height = Number(a.height);
            a.width = Number(a.width);
            const parseSideData = getParseSideData(a);

            // 聚合应用
            if (checkApp(a).isCompactApp) {
                appGroupMap[a.cardid] = parseSideData.cardList = a.children || []; // 常用应用数据 => 侧拉
                a.children = []; // 清空聚合应用数据
            }

            // 这里处理 partname => sidedata.name (partname有可能通过脚本直接预置了，需要赋值给侧拉)
            const partNameValue = getMultiLangValue('partname', a, 'name');
            const menuNameValue = getMultiLangValue('menuitemname', a, 'name');
            const nameValue = _.merge(menuNameValue, partNameValue);
            const SideNameValue = parseSideData.name;
            if (SideNameValue && typeof SideNameValue === 'object') {
                for (let k in nameValue) {
                    if (!SideNameValue[k] || !SideNameValue[k].value) {
                        SideNameValue[k] = nameValue[k];
                    }
                }
            } else {
                parseSideData.name = nameValue;
            }

            if (a.iscommon_configuration) { // 开启公共配置
                let { publicData = {} } = parseSideData;
                const { name: publicName = {} } = publicData;
                for (let k in publicName) {
                    if (!publicName[k] || !publicName[k].value) {
                        delete publicName[k]; // 删除无效值
                    }
                }
                // 优先取 parseSideData.name 这个是合并的partname和menuname
                // partname可能是预置脚本的（后台之恶能改这个字段，无法更给blob里的），另外保存时也会将侧拉的值同步至partname字段
                // 所以取这个值就可以
                publicData.name = _.merge(publicName, parseSideData.name);
                const defalutPublicData = getPublicData();
                publicData = _.merge(defalutPublicData, publicData); // 合并默认值
                parseSideData.publicData = publicData;
                delete parseSideData.name;
            }

            a.sideData = parseSideData;
            a.sideData.multilangTranslates = a.multilangTranslates; // 侧拉面板内多语数据

            customDeal && customDeal(a);
        });
    });
    return appGroupMap;
};

// 获取默认公共配置数据
export const getPublicData = (name, obj) => {
    const langIndex = getCurrentLangIndex();
    const publicData = {
        nameShow: true,
        background: {
            type: 'color',
            color: WhiteHex,
        },
    };
    if (obj) {
        let languageMeta = getBusinessInfo().languageMetas;
        publicData.name = languageMeta.reduce((values, { index }) => {
            if (index === '1') {
                index = '';
            }

            values[`name${index}`] = { value: obj[`label${index}`] };
            return values;
        }, {});
    } else if (name) {
        // 这里初始化赋当前语言的值即可，其余语言的内容未知，不处理
        publicData.name = { [`name${langIndex}`]: { value: name } };
    }
    return publicData;
};

const getParseSideData = app => {
    // 侧拉数据
    let parseSideData;
    try {
        parseSideData = JSON.parse(app.component_configuration);
    } catch (error) {
        parseSideData = {};
    }
    if (app.permission_code) { // 权限处理（目前针对指标卡）
        parseSideData.permission_code = app.permission_code;
    }
    return parseSideData;
};

// 背景色映射（默认 =》 暗黑主题）
const WhiteHex = '#FFFFFF';
const BlackColorMap = {
    [WhiteHex]: '#292930',
    '#F5F7FC': '#424960',
    '#F4FDF9': '#3B4B45',
    '#FEF7EC': '#4A4239',
    '#FDF2F2': '#573F3F',
    '#F4F3FC': '#3F4152',
};
const BlackBorderMap = {
    '#292930': '#53535D',
    '#424960': '#424E73',
    '#3B4B45': '#495E56',
    '#4A4239': '#524D43',
    '#573F3F': '#654E4E',
    '#3F4152': '#565B79',
};
// 获取颜色数据
export const getSpecialColorList = (themeType, count, includeWhite = false) => {
    const colorList = [];
    for (let k in BlackColorMap) {
        if (!includeWhite && k === WhiteHex) { continue; } // 不包含白色则跳过
        if (count && colorList.length === count) { break; }

        if (themeType === 'black') {
            colorList.push({ color: BlackColorMap[k], borderColor: BlackBorderMap[BlackColorMap[k]] });
        } else {
            colorList.push({ color: k });
        }
    }
    colorList.push(themeType === 'black' ? { key: 'custom', borderColor: '#565B79' } : { key: 'custom' }); // 自定义
    return colorList;
};

// 获取颜色
export const getSpecialColor = (color, themeType) => {
    const colorMap = { ...BlackColorMap };
    for (let k in colorMap) {
        if (themeType === 'black') {
            if (k.includes(color.toLocaleUpperCase())) { // 白色有可能是'#ffffff'或者'#fff'或者其他，所以用includes判断
                return colorMap[k];
            }
        } else {
            if (colorMap[k] === color) {
                return k;
            }
        }
    }
    return color;
};
export const defaultCardArrangement = 'upDown';
// 常用应用排列方式
export const getAppGroupOrderType = (value = defaultCardArrangement) => {
    let obj = {
        flex: {
            flexDirection: 'row',
            justifyContent: 'flex-start',
        },
        appName: {
            marginLeft: '8px',
            width: 'auto',
            padding: 0,
        },
    };
    if (value === defaultCardArrangement) {
        obj = {
            flex: { flexDirection: 'column' },
            appName: { marginTop: '3px' },
        };
    }
    return obj;
};

export const APPGROUPCONSTANT = {
    APP: 'app',
    RECENTVISIT,
};

export const getAppTabArr = (sideData = {}) => {
    const { publicData = '', appTab } = sideData;
    let name = publicData && getCurrentLangText('name', publicData) || '';
    if (appTab) {
        appTab.forEach(item => {
            if (item.key === APPGROUPCONSTANT.APP) {
                item.title = name;
            }
            if (item.key === APPGROUPCONSTANT.RECENTVISIT) {
                item.title = langCheck("0000PUB-000342");
            }
        });
        return appTab;
    }
    return [
        {
            key: APPGROUPCONSTANT.APP,
            title: name,
            show: true, // 显示
            select: true, // 选中
        },
        {
            key: APPGROUPCONSTANT.RECENTVISIT,
            title: langCheck("0000PUB-000342"), // 最近访问
            show: true,
            select: false,
        },
    ];
};

// 获取有效的联动关系
export const getEffectiveLinkData = (linkData = [], groups = []) => {
    const effectiveData = [];
    const allApps = _.uniqBy(groups.map(item => item.apps).flat(), 'cardid');
    linkData.forEach(item => {
        const effectiveApp = allApps.find(app => app.cardid === item.source_partid);
        if (effectiveApp) {
            const effectiveLink = _.cloneDeep(item);
            effectiveLink.linkConfigVO = effectiveLink.linkConfigVO.filter(linkedApp => allApps.some(app => app.cardid === linkedApp.key));
            effectiveData.push(effectiveLink);
        }
    });
    return effectiveData;
};